import { extractOgImage } from "@/lib/extract-og-image";

// Shared by any form that lets a page/entity override the project-wide
// headline, description, or social share image, so the UI can show
// admins what they're inheriting vs. overriding. See InheritedTextHint.vue
// and InheritedImageHint.vue.
export default {
  computed: {
    siteDefaults() {
      const project = this.currentUser?.active_project || {};
      return {
        headline: project.headline || "",
        description: project.description || "",
      };
    },
    siteDefaultSocialShareImageUrl() {
      return extractOgImage(this.currentUser?.active_project?.meta_tags);
    },
  },
};
